import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Print = forwardRef<SVGSVGElement, SvgIconProps>(
  function Print(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M15.92 7.43h1.54c.8 0 1.46.67 1.46 1.48v4.35c0 .82-.65 1.48-1.46 1.48h-.5l-.4-2.36a.92.92 0 00-.91-.77h-7.3a.93.93 0 00-.9.77l-.42 2.36h-.49c-.39 0-.76-.15-1.03-.43a1.49 1.49 0 01-.43-1.05V8.91c0-.39.15-.77.43-1.04.27-.28.64-.44 1.03-.44h1.38v-2.3c0-.35.23-.63.5-.63h7c.28 0 .5.28.5.63v2.3zm-1 0V6c0-.28-.16-.5-.37-.5H9.3c-.2 0-.38.22-.38.5v1.43h6zm2.38 2.2c.15 0 .28-.07.39-.17a.55.55 0 00-.18-.9.54.54 0 00-.6.12c-.15.16-.2.4-.11.6.08.2.28.34.5.34zM8.35 12.5h7.16a.5.5 0 01.5.4l1.17 6a.5.5 0 01-.49.6H7.35a.5.5 0 01-.5-.58l1-6a.5.5 0 01.5-.42zm.88 1a.5.5 0 00-.5.41l-.7 4a.5.5 0 00.49.59h6.79a.5.5 0 00.49-.6l-.84-4a.5.5 0 00-.49-.4H9.23z" />
      </SvgIcon>
    )
  },
)

export default Print
